import { ContentNotFoundError } from '../common/errors';

export function expectContent<T>(value: T | null | undefined, message?: string): NonNullable<T> {
	if (value === null || value === undefined) {
		throw new ContentNotFoundError({
			message: message ?? 'Content not found',
		});
	}

	return value;
}
